import React, { useState, useEffect } from "react";
import { Grid, Typography, Checkbox, Popover, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../../Sass/Common.scss";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ReactComponent as ListDots } from "../../../Assets/Icons/ListDots.svg";
import HtmlTooltipMain from "../../../Components/Common/HtmlTooltipMain";
import {
  setLocalStorage,
  getLocalStorage,
  capitalizeFirstLetter,
  getNewOrder,
} from "utils/generalUtils";
import useViewport from "Hooks/useViewport";
const useStyle = makeStyles((theme) => ({
  rsCustomizeTablePopper: {
    background: theme.palette.common.white,
    padding: "10px 15px",
    width: "fit-content",
    zIndex: 50,
    borderRadius: "4px",
    "&>h4": {
      fontWeight: "bold",
      marginBottom: "8px",
      marginTop: "15px",
    },
  },
  rsReorderDetailViewTableBody: {
    "&>div": {
      "&:first-child": {
        paddingLeft: 18,
      },
      "&>span": {
        cursor: "pointer",
        display: "flex",
        padding: "3px",
      },
    },
  },
  rsReorderColumnItem: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: theme.palette.common.white,
    padding: "0 10px 0",
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    paddingRight: 30,
    boxShadow: `0px 0px 4px -2px ${theme.palette.common.black}`,
    minWidth: "220px",
    maxWidth: "220px",
    "&>span": {
      "&:last-child": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
    },
    "&>h6": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  rsCustomizeTableColumn: {
    display: "flex",
  },
  msoCustomizeTableColumn: {
    display: "flex",
  },
  rsListDotIcon: {
    cursor: "move",
  },
  rsListAlignment: {
    display: "flex",
    marginBottom: "11px",
    justifyContent: "space-between",
    "&>": {
      marginTop: "15px",
    },
  },
  rsStatusMenuList: {
    display: "block",
    textAlign: "center",
    marginBottom: "10px",
  },
  rsDriverMenu: {
    top: "25px  !important",
    [theme.breakpoints.down(400)]: {
      top: "40px !important",
    },
  },
}));

const TableColumnShowMenu = ({
  open,
  setOpen,
  anchorEl,
  tableColumns,
  setTableColumns,
  onOrderChange,
  tableCells,
  surgeryRecordActionType,
  staffRecordActionType,
  patientActionType,
  orderRecordActionType,
  collationActionType,
  pharmacyRecordActionType,
  moduleName,
  tableViewType = "basic",
  handleOnChangeTableType,
  isPrescriptionTracking,
}) => {
  const classes = useStyle();
  const [columnsSequence, setColumnsSequence] = useState(() => {
    const savedSeq = getLocalStorage(
      `dynamicColumnSequence${capitalizeFirstLetter(moduleName)}`
    );
    if (savedSeq) {
      const arr = savedSeq.split(",").filter(Boolean);
      if (arr.length > 0) return arr;
    }
    return Object.keys(tableCells || {});
  });
  const handleClose = () => {
    setOpen(false);
  };
  const { width } = useViewport();
  const tableViews = {
    basic: {
      title: "Basic",
      value: "basic",
    },
    advance: {
      title: "Advance",
      value: "advance",
    },
  };
  const [currentTableView, setCurrentTableView] = useState(tableViewType);

  const onHandleChange = (columnKey, isTick) => {
    const tableColumn = {
      ...tableColumns,
      [columnKey]: {
        ...tableColumns[columnKey],
        show: !isTick,
      },
    };
    setTableColumns(tableColumn);
  };

  const handleDragEnd = (data) => {
    if (!data.destination) {
      return false;
    }
    if (
      data.destination.droppableId === data.source.droppableId &&
      data.destination.index === data.source.index
    ) {
      return false;
    }

    let newOrder = Array.from(columnsSequence);
    const [removed] = newOrder.splice(data.source.index, 1);
    newOrder.splice(data.destination.index, 0, removed);
    setColumnsSequence(newOrder);

    if (typeof onOrderChange === "function") {
      onOrderChange(getNewOrder(newOrder, tableColumns));
    }
  };

  useEffect(() => {
    if (columnsSequence && columnsSequence.length > 0) {
      setLocalStorage(
        `dynamicColumnSequence${capitalizeFirstLetter(moduleName)}`,
        columnsSequence
      );
    }
  }, [columnsSequence, moduleName]);

  useEffect(() => {
    if (tableColumns && Object.keys(tableColumns).length > 0) {
      const allVisibleColumns = Object.values(tableColumns)
        .filter(({ show, showValue }) => show && showValue)
        .map(({ id }) => id);
      setLocalStorage(
        "dynamicColumn" + capitalizeFirstLetter(moduleName),
        allVisibleColumns
      );
    }
  }, [tableColumns, moduleName]);

  useEffect(() => {
    if (typeof handleOnChangeTableType === "function") {
      handleOnChangeTableType(currentTableView);
    }
    setLocalStorage(
      "dynamicTableView" + capitalizeFirstLetter(moduleName),
      currentTableView
    );
  }, [currentTableView]);

  return (
    <>
      <Popover
        style={{ marginTop: "5px" }}
        open={Boolean(open)}
        anchorEl={anchorEl ? anchorEl : open}
        onClose={() => handleClose()}
        anchorOrigin={{
          vertical: "bottom",
          horizontal:
            pharmacyRecordActionType == "PharmacyDetails"
              ? width < 600
                ? "left"
                : "right"
              : staffRecordActionType === "staffDragDrop"
                ? width < 786
                  ? "left"
                  : "right"
                : ["unCollectedAction", "CollectedAction"].indexOf(
                  collationActionType
                ) !== -1
                  ? width < 651
                    ? "left"
                    : "right"
                  : orderRecordActionType === "orderDetails"
                    ? width < 500
                      ? "left"
                      : "right"
                    : patientActionType === "patientDetails"
                      ? width < 550
                        ? "left"
                        : "right"
                      : "right",
        }}
        // transformOrigin={{
        //   vertical: "bottom",
        //   horizontal: "right",
        // }}
        className={
          width < 768 && collationActionType === "unCollectedAction"
            ? classes.rsDriverMenu
            : ""
        }
        // PaperProps={{
        //   style: {
        //     height:
        //       surgeryRecordActionType === "surgeryDragDrop"
        //         ? "auto"
        //         : staffRecordActionType === "staffDragDrop"
        //         ? "28%"
        //         : patientActionType === "patientDetails"
        //         ? "auto"
        //         : patientActionType === "patientPharmacyDetails"
        //         ? "42%"
        //         : pharmacyRecordActionType === "PharmacyDetails"
        //         ? "auto"
        //         : orderRecordActionType === "orderDetails"
        //         ? "auto"
        //         : collationActionType === "unCollectedAction"
        //         ? "49%"
        //         : collationActionType === "unCollectedPharmacyActionDriverMob"
        //         ? "49%"
        //         : collationActionType === "CollectedAction"
        //         ? "36%"
        //         : collationActionType === "userCollectedAction"
        //         ? "300px"
        //         : collationActionType === "collectedPharmacyAction"
        //         ? "28%"
        //         : surgeryRecordActionType === "pharmacyDragDrop"
        //         ? "43%"
        //         : collationActionType === "unCollectedPharmacyAction"
        //         ? "42%"
        //         : "28%",
        //     borderRadius: "8px",
        //   },
        // }}
        // style={{
        // marginTop:
        //   surgeryRecordActionType === "surgeryDragDrop"
        //     ? width > 785
        //       ? "120px"
        //       : width > 768
        //       ? "170px"
        //       : "200px"
        //     : staffRecordActionType === "staffDragDrop"
        //     ? width > 786
        //       ? "190px"
        //       : "280px"
        //     : pharmacyRecordActionType === "PharmacyDetails"
        //     ? width > 768
        //       ? "118px"
        //       : width > 600
        //       ? "150px"
        //       : width > 420
        //       ? "180px"
        //       : "220px"
        //     : orderRecordActionType === "orderDetails"
        //     ? width > 768
        //       ? "120px"
        //       : width > 500
        //       ? "150px"
        //       : "185px"
        //     : ["unCollectedAction", "CollectedAction"].indexOf(
        //         collationActionType
        //       ) !== -1
        //     ? width > 768
        //       ? "120px"
        //       : width > 651
        //       ? "145px"
        //       : "180px"
        //     : patientActionType === "patientDetails"
        //     ? width > 830
        //       ? "118px"
        //       : width > 768
        //       ? "160px"
        //       : width > 550
        //       ? "190px"
        //       : width > 400
        //       ? "230px"
        //       : "280px"
        //     : collationActionType === "userCollectedAction"
        //     ? "234px"
        //     : collationActionType === "collectedPharmacyAction"
        //     ? "120px"
        //     : surgeryRecordActionType === "pharmacyDragDrop"
        //     ? "120px"
        //     : collationActionType === "unCollectedPharmacyActionDriverMob"
        //     ? "186px"
        //     : collationActionType === "collectedPharmacyActionDriver"
        //     ? "198px"
        //     : patientActionType === "patientPharmacyDetails"
        //     ? "118px"
        //     : collationActionType === "unCollectedPharmacyAction"
        //     ? "192px"
        //     : "176px",
        // top:
        //   collationActionType === "unCollectedPharmacyActionDriverMob"
        //     ? "60px"
        //     : collationActionType === "CollectedActionDriver"
        //     ? "68px"
        //     : "0",
        // }}
        transition
      >
        <Grid className={classes.rsCustomizeTablePopper}>
          <Typography color="secondary" bold variant="h4">
            Columns
          </Typography>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="0">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  <Grid>
                    {Object.keys(tableColumns)?.map((columnKey, i) => (
                      <>
                        {tableColumns[columnKey].showValue === true && (
                          <Draggable
                            key={columnsSequence[i]}
                            draggableId={columnsSequence[i]}
                            index={i}
                          >
                            {(DraggableProvider) => (
                              <Grid
                                ref={DraggableProvider.innerRef}
                                className={classes.rsReorderColumnItem}
                                {...DraggableProvider.draggableProps}
                              >
                                <span {...DraggableProvider.dragHandleProps}>
                                  <ListDots className={classes.rsListDotIcon} />
                                </span>
                                <Checkbox
                                  value={columnsSequence[i]}
                                  checked={tableColumns[columnKey].show}
                                  onChange={() => {
                                    onHandleChange(
                                      columnKey,
                                      tableColumns[columnKey].show
                                    );
                                  }}
                                />
                                <HtmlTooltipMain
                                  title={
                                    tableCells[columnKey]?.label ||
                                    tableColumns[columnKey]?.label
                                  }
                                >
                                  <Typography
                                    color="secondary"
                                    regular
                                    variant="h6"
                                  >
                                    {!isPrescriptionTracking && moduleName == 'unCollected' && tableCells[columnKey]?.label == 'ITEMS' ? "UNCOLLECTED" : tableCells[columnKey]?.label ||
                                      tableColumns[columnKey]?.label}
                                  </Typography>
                                </HtmlTooltipMain>
                              </Grid>
                            )}
                          </Draggable>
                        )}
                      </>
                    ))}
                  </Grid>
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {["orderDetails", "orderPharmacyDetails"].indexOf(
            orderRecordActionType
          ) !== -1 && (
              <>
                <Box className={classes.rsListAlignment}>
                  <Typography color="secondary" bold variant="h4">
                    Table View
                  </Typography>
                </Box>
                {Object.keys(tableViews).map((key) => {
                  return (
                    <>
                      <Grid
                        className={classes.rsReorderColumnItem}
                        style={{
                          backgroundColor:
                            currentTableView === key ? "#7BC04410" : "white",
                          border:
                            currentTableView === key
                              ? "1px solid rgba(123, 192, 68, 0.5)"
                              : "black",
                        }}
                      >
                        <Checkbox
                          value={key}
                          checked={currentTableView === key}
                          onChange={() => setCurrentTableView(key)}
                        />
                        <Typography color="secondary" regular variant="h6">
                          {tableViews[key].title}
                        </Typography>
                      </Grid>
                    </>
                  );
                })}
              </>
            )}
        </Grid>
      </Popover>
    </>
  );
};

export default TableColumnShowMenu;
